export default "__VITE_ASSET__D0if3AnJ__"